export default function Security() {
  const securityFeatures = [
    {
      title: 'AES-256 Encryption',
      description: 'Bank-level encryption that keeps your data completely secure from any threats'
    },
    {
      title: 'No-Logs Policy',
      description: 'We never store your browsing history, connection logs, or personal information'
    },
    {
      title: 'Kill Switch Protection',
      description: 'Automatically blocks internet if VPN connection drops to prevent data leaks'
    }
  ];

  return (
    <section id="security" className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-teal-400 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative hidden md:block">
            <div className="relative w-full h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/a129e9993c839c96659b273ac1f60088.jpg"
                alt="Security Illustration"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          
          <div className="text-white space-y-8">
            <div>
              <span className="inline-block bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
                MILITARY-GRADE ENCRYPTION
              </span>
              <h2 className="text-5xl font-bold leading-tight mb-6">
                Your Privacy Is<br />
                Our Priority
              </h2>
            </div>
            
            <div className="space-y-6">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                    <p className="text-gray-300 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-white hover:text-gray-900 transition-all flex items-center gap-3 cursor-pointer whitespace-nowrap mt-8">
              Learn More
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
